import { render, staticRenderFns } from "./kegel.vue?vue&type=template&id=45f8bae6&scoped=true&"
import script from "./kegel.vue?vue&type=script&lang=js&"
export * from "./kegel.vue?vue&type=script&lang=js&"
import style0 from "./kegel.vue?vue&type=style&index=0&id=45f8bae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f8bae6",
  null
  
)

export default component.exports